
import React, { useRef } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";

DataTable.use(DT);

const WorkflowsTable = ({ workflows = [], isDataSet = false, hideTitle = false, hideButtons = false, showAddExisting = false, mode = null, onSelect = () => { } }) => {
  const tableRef = useRef(null);

  const tableData = workflows.map((workflow) => {
    return [workflow.public_id, workflow.name, workflow.description, ""];
  });

  return (
    <div className="workflowstable">
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 25,
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default WorkflowsTable;
